import axios from "axios";
import { getDocumentMeta } from "utils/getDocumentMeta";

export const ciamSessionSwitchRequest = async (params: {
  patient_id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: number;    // digits only
  date_of_birth: string; // "YYYY-MM-DD"
}): Promise<void> => {
  const { patient_id, first_name, last_name, email, phone_number, date_of_birth } = params;
  const path = getDocumentMeta("dph_routing") === "1"
    ? "/dph-handoff/patient_sessions/switch"
    : "/api/patient_sessions/switch";
  const { data } = await axios.post(path, {
    patient_id, first_name, last_name, email, phone_number, date_of_birth
  },{
    headers: {
        'Content-Type': 'application/json'
    }
});

  return data;
};
